import client from './client';
import type { User } from '@/types/api';

export const usersApi = {
  getAll: async (): Promise<User[]> => {
    const res = await client.get('/users');
    return res.data;
  },

  getById: async (id: string): Promise<User> => {
    const res = await client.get(`/users/${id}`);
    return res.data;
  },

  create: async (data: {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    role?: string;
  }): Promise<User> => {
    const res = await client.post('/users', data);
    return res.data;
  },

  update: async (id: string, data: {
    email?: string;
    firstName?: string;
    lastName?: string;
    role?: string;
  }): Promise<User> => {
    const res = await client.put(`/users/${id}`, data);
    return res.data;
  },

  updateRole: async (id: string, role: string): Promise<User> => {
    const res = await client.patch(`/users/${id}/role`, { role });
    return res.data;
  },

  updateStatus: async (id: string, isActive: boolean): Promise<User> => {
    const res = await client.patch(`/users/${id}/status`, { isActive });
    return res.data;
  },

  resetPassword: async (id: string, password: string): Promise<void> => {
    await client.post(`/users/${id}/reset-password`, { password });
  },
};
